<div class="main-preview-pagination">
  <div class="next-page" (click)="nextPage()"></div>
  <div class="previous-page" (click)="previousPage()"></div>
  <div class="current-page">
    Page {{ page }} of {{ totalPages }} - Total: {{ totalItems }}
  </div>
</div>
